import { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { isNeedMock, resolveResError } from './helpers'
import { getParams } from '@/utils'
import SSOClient from '@kuailu/sso'
import { useUserStore } from '@/store'

class ResponseObj {
  code: string
  data?: Record<string, any>
  msg?: string

  constructor(code?: string, data?: Record<string, any>, msg?: string) {
    this.code = code ?? ''
    this.data = data
    this.msg = msg
  }
}
// 设置baseURL
const _headers2 = {}
if (
  import.meta.env.MODE === 'development' &&
  getParams('baseURL') &&
  getParams('baseURL') !== 'dev'
) {
  _headers2['x-env-header'] = getParams('baseURL') + 'ServiceInstance'
}

export function setupInterceptors(axiosInstance: AxiosInstance) {
  // -------------------------请求拦截----------------------------
  // 请求成功拦截
  function reqResolve(config: InternalAxiosRequestConfig<any>) {
    let _headers = { ...config['headers'] }

    if (
      import.meta.env.MODE === 'development' &&
      getParams('baseURL') &&
      getParams('baseURL') !== 'dev'
    ) {
      _headers = {
        ..._headers,
        ..._headers2
      }
    }

    // 处理需要mock的请求
    if (config.url && isNeedMock(config.url) && import.meta.env.DEV) {
      console.log('mock', config.url)
      config.baseURL = '/mock'
    }

    return {
      ...config,
      headers: _headers
    } as InternalAxiosRequestConfig
  }

  // 请求错误拦截
  function reqReject(error: AxiosError) {
    return Promise.reject(error)
  }
  axiosInstance.interceptors.request.use(reqResolve, reqReject)

  // -------------------------返回拦截----------------------------
  // 成功code码，特定错误码不需要提示请传入hideErrMsgCodes: ['5xx']
  const SUCCESS_CODE = '200'

  // 返回成功拦截
  function resResolve(response: AxiosResponse<ResponseObj> | any) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data, status, config, headers } = response
    if (headers['content-type']?.toString()?.includes('json')) {
      if (data?.code === SUCCESS_CODE) {
        return Promise.resolve(data)
      }

      if (data?.errorCode === 'E00000031' || data?.errorCode === 'E00000046') {
        const msg = data?.msg || ''
        window.$message.warning(msg)
        return Promise.resolve(new ResponseObj(code, data.data, msg))
      }
      const code = data?.code ?? status.toString()
      // 根据code处理对应的操作，并返回处理后的message
      const msg = data?.msg ?? '未知异常'

      // 是否隐藏错误提示
      const isHideErrMsg = config.hideErrMsg
      // 是否隐藏特定code错误提示
      const isHideErrMsgWithCodes =
        Array.isArray(config.hideErrMsgCodes) && config.hideErrMsgCodes.includes(code)

      !isHideErrMsg && !isHideErrMsgWithCodes && msg && window.$message.error(msg)

      return Promise.resolve(new ResponseObj(code, data.data, msg))
    }
    return Promise.resolve(data)
  }

  // 返回错误拦截
  async function resReject(error: AxiosError<ResponseObj>) {
    if (!error || !error.response) {
      const code = error?.code
      /** 根据code处理对应的操作，并返回处理后的message */
      const msg = resolveResError(code, error.message)

      msg && window.$message.error(msg)
      return Promise.reject(new ResponseObj(code, {}, msg))
    }

    const { data, status } = error.response
    const code = data?.code ?? status.toString()

    if (code === '401') {
      SSOClient.launchLogout()
      useUserStore().goBackHome()
      // 登录失效跳转登录页
      // useUserStore().redirectToLogin()
    }

    const msg = data?.msg ?? error.message
    /** 需要错误提醒 */
    msg && window.$message.error(msg)
    return Promise.reject(new ResponseObj(code, data.data || {}, msg))
  }
  axiosInstance.interceptors.response.use(resResolve, resReject)
}
